var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item" }, [
    _c("div", { staticClass: "item__title" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.dateParser(_vm.exec.order_date)) +
          "\n        "
      ),
      _c("span", { staticClass: "number" }, [
        _vm._v(_vm._s(_vm.exec.order_num)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "status" }, [
        _vm._v(_vm._s(_vm._f("getStatus")(_vm.exec.status))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item_sum" }, [
      _c("b", [_vm._v("Сумма:")]),
      _vm._v(" "),
      _vm.exec.sum
        ? _c("span", [
            _vm._v(_vm._s(_vm.moneyFormat(_vm.exec.sum, 2)) + " "),
            _c("i", { staticClass: "uk-icon-rub" }),
          ])
        : _c("span", [_vm._v("-")]),
    ]),
    _vm._v(" "),
    _vm.exec.order_object
      ? _c("div", { staticClass: "item__object" }, [
          _c("b", [_vm._v("Предмет исполнения:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.exec.order_object))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.exec.document_date
      ? _c("div", { staticClass: "item__date" }, [
          _c("b", [_vm._v("Дата исполнительного документа:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.dateParser(_vm.exec.document_date)))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.exec.document_num
      ? _c("div", { staticClass: "item__number" }, [
          _c("b", [_vm._v("№ исполнительного документа:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.exec.document_num))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.exec.dep_address
      ? _c("div", { staticClass: "item__address" }, [
          _c("b", [_vm._v("Адрес отдела судебных приставов:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.exec.dep_address))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.exec.end_reason
      ? _c("div", { staticClass: "item__end" }, [
          _c("b", [_vm._v("Основание окончания:")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "law",
              attrs: { title: _vm.getReasonText(_vm.exec.end_reason) },
            },
            [_vm._v(_vm._s(_vm._f("getReasonArticle")(_vm.exec.end_reason)))]
          ),
          _vm._v(
            "\n        (на " +
              _vm._s(_vm.dateParser(_vm.exec.end_date)) +
              ")\n    "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }